import { Component, OnInit } from '@angular/core';
import { Router, Route } from "@angular/router";

import { Usuario } from '../Models/Usuario';
import { PuntoVisitaLocalizacion } from '../Models/PuntoVisitaLocalizacion';

import { UtilesService } from '../services/utiles.service';
import { PuntoVisitaService } from '../services/punto-visita.service';
import { GlobalsService } from '../services/globals.service';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {


  public usuario: Usuario;
  public contador: string;
  public interval: any;

  constructor(
    private utilesService: UtilesService,
    private router: Router,
    private puntoVisitaService: PuntoVisitaService,
    private globalService: GlobalsService
  ) { }

  ngOnInit() {


    this.usuario = this.utilesService.usuarioActivo();
    this.ContadorPuntoVisitaLocalizacion();

    this.interval = setInterval(() => {
      this.ContadorPuntoVisitaLocalizacion();
    }, 60000);

  }

  logout() {

    this.utilesService.limpiarLogin();
    this.router.navigate(['/login']);

  }

  ContadorPuntoVisitaLocalizacion() {
    try {


      this.puntoVisitaService.ObtenerContadorPuntoVisitaLocalizacion(this.globalService.ObtenerCompania()).subscribe(
        data => {
          this.contador = data;
         
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("ContadorPuntoVisitaLocalizacion: " + error);
    }

  }


}
